import { render, staticRenderFns } from "./helpService.vue?vue&type=template&id=61e58884"
import script from "./helpService.vue?vue&type=script&lang=js"
export * from "./helpService.vue?vue&type=script&lang=js"
import style0 from "./helpService.vue?vue&type=style&index=0&id=61e58884&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports